// extracted by mini-css-extract-plugin
export default {"container":"updateBlog_container__+JZFS","wrapper":"updateBlog_wrapper__lBb-Z"};